import { Injectable } from '@angular/core';

// Tipos de estilos de mapa base de Mapbox
export type TipoMapaBase =
  | 'streets'
  | 'satellite'
  | 'outdoors'
  | 'light'
  | 'dark';

@Injectable({ providedIn: 'root' })
export class ServiceStorageVehiculos {
  private readonly TIPO_MAPA_BASE_KEY = 'tipoMapaBaseGlobal';
  private tipoMapaBaseByIndex: Record<number, TipoMapaBase> = {};
  private defaultTipoMapaBase: TipoMapaBase = 'streets';

  constructor() {}

  /** Inicializa el estilo de mapa base y lo devuelve */
  public initBaseStyle(mapaSeleccionado: number): string {
    const storedGlobal = localStorage.getItem(
      this.TIPO_MAPA_BASE_KEY,
    ) as TipoMapaBase | null;
    this.defaultTipoMapaBase = storedGlobal || 'streets';
    const tipoMapaBase = this.getTipoMapaBaseForSelected(mapaSeleccionado);
    return this.getMapboxStyle(tipoMapaBase);
  }

  /** Obtiene el tipo de mapa base del mapa seleccionado */
  public getTipoMapaBaseForSelected(mapaSeleccionado: number): TipoMapaBase {
    const idx = Math.max(0, mapaSeleccionado - 1);
    return this.getTipoMapaBaseForIndex(idx);
  }

  /** Devuelve el estilo de Mapbox para un tipo */
  public getMapboxStyle(tipo: TipoMapaBase): string {
    const estilos: Record<TipoMapaBase, string> = {
      streets: 'mapbox://styles/mapbox/streets-v12',
      satellite: 'mapbox://styles/mapbox/satellite-streets-v12',
      outdoors: 'mapbox://styles/mapbox/outdoors-v12',
      light: 'mapbox://styles/mapbox/light-v11',
      dark: 'mapbox://styles/mapbox/dark-v11',
    };
    return estilos[tipo] || estilos['streets'];
  }

  /** Devuelve el tipo de mapa base para un índice específico */
  public getTipoMapaBaseForIndex(index: number): TipoMapaBase {
    if (this.tipoMapaBaseByIndex[index]) {
      return this.tipoMapaBaseByIndex[index];
    }
    const key = this.getInstanceStorageKey(index);
    const stored = localStorage.getItem(key);
    if (stored) {
      this.tipoMapaBaseByIndex[index] = stored as TipoMapaBase;
      return this.tipoMapaBaseByIndex[index];
    }
    return this.defaultTipoMapaBase;
  }

  /** Guarda el tipo de mapa base para un índice */
  public saveTipoMapaBase(index: number, tipo: TipoMapaBase): void {
    this.tipoMapaBaseByIndex[index] = tipo;
    const key = this.getInstanceStorageKey(index);
    localStorage.setItem(key, tipo);
  }

  /** Obtiene la clave de almacenamiento local para un índice */
  private getInstanceStorageKey(index: number): string {
    return `tipoMapaBase_${index}`;
  }

  /** Guarda el estado del mapa (centro y zoom) */
  public saveMapState(
    center: [number, number],
    zoom: number,
    index: number,
    nombreMap: string,
  ): void {
    localStorage.setItem(`mapZoomVehiculos_${index}`, zoom.toString());
    localStorage.setItem(
      `mapCenter_${nombreMap}_${index}`,
      JSON.stringify(center),
    );
  }

  /** Carga el estado del mapa guardado */
  public loadMapState(
    index: number,
    nombreMap: string,
  ): { center?: [number, number]; zoom?: number } {
    const zoomStr = localStorage.getItem(`mapZoomVehiculos_${index}`);
    const centerStr = localStorage.getItem(`mapCenter_${nombreMap}_${index}`);

    return {
      center: centerStr ? JSON.parse(centerStr) : undefined,
      zoom: zoomStr ? parseFloat(zoomStr) : undefined,
    };
  }

  public loadSeleccionadosFromSessionStorage(key: string): any[] | undefined {
    try {
      const data = sessionStorage.getItem(key);
      if (data) {
        const parsed = JSON.parse(data) as any[];
        // IMPORTANTE: Limpiar filtrosSeleccionados al cargar desde sessionStorage
        // ya que es un estado transitorio que no debe persistir entre cargas.
        // Si se mantiene, puede causar que no se muestren vehículos al iniciar
        // porque idsVehiculosFiltrados puede quedar vacío de una sesión anterior.
        if (Array.isArray(parsed)) {
          return parsed.map((item) => ({
            ...item,
            filtrosSeleccionados: undefined,
          }));
        }
        return parsed;
      }
    } catch (error) {
      console.error('Error al cargar desde sessionStorage:', error);
    }
    return undefined;
  }
}
